export default __webpack_public_path__ + "static/media/snupps.d59bd6ba.svg";